import { render, staticRenderFns } from "./NuevoParte.vue?vue&type=template&id=deeda638&"
import script from "./NuevoParte.vue?vue&type=script&lang=js&"
export * from "./NuevoParte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports